/**
 * Try to keep this file light and load it async
 */

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.lazyClass = 'lazy';
window.lazySizesConfig.preloadClass = 'lazy--preload';
window.lazySizesConfig.loadingClass = 'lazy--loading';
window.lazySizesConfig.loadedClass = 'lazy--loaded';

import WebFont from 'webfontloader'; // Load all your fonts https://github.com/typekit/webfontloader
import 'picturefill'; // Picture & srcet polyfill https://github.com/scottjehl/picturefill
import 'lazysizes'; // Lazyloading for normal and responsive images https://github.com/aFarkas/lazysizes
import './modules/lazy-helpers';


// If we're developing locally, use '/dist/', otherwise use variable set in document header by Stage
let resourceUrl = process.env.LOCAL_MODE ? '/dist/' + process.env.RESOURCE_FOLDER + '/' : window.RESOURCE_PATH;

const WebFontConfig = {
  custom: {
    families: ['Sucrose:n4,n7'],
    urls: [`${resourceUrl}css/japa-extranet-fonts.min.css`]
  },
  active: function() {
    try {
      sessionStorage.webfontsLoaded = true;
    } catch(e) {
      // no session storage available
    }
  },
  typekit: { id: 'gge6rzp' } //old project id zfo8xsn , new gge6rzp
}

WebFont.load(WebFontConfig);
